import type { useContentCreatorDetailsPanelContentCreatedByQuery as DetailsPanelContentCreatedByQuery } from '../hooks/__types__/useContentCreatorDetailsPanelContentCreatedByQuery';
import { hasAccountId } from '../userUtils';

export const normalizeContentCreatorData = (data?: DetailsPanelContentCreatedByQuery) => {
	const contentNode = data?.content?.nodes?.[0];
	const createdBy = contentNode?.history?.createdBy;
	const generatedBy = contentNode?.contentProperties?.latest?.generatedBy;

	// If the page was generated by ONBOARDING, show "Confluence" as the creator
	if (generatedBy === 'ONBOARDING') {
		return {
			accountId: null,
			displayName: 'Confluence',
			profilePicturePath: 'confluence-icon',
		};
	}

	return {
		accountId: hasAccountId(createdBy) ? createdBy?.accountId : '',
		displayName: createdBy?.displayName ?? '',
		profilePicturePath: createdBy?.profilePicture?.path,
	};
};
